import {createAsyncThunk} from '@reduxjs/toolkit'

import {PAY} from '@web/core/urls'
import {changeBrowserLocation} from '@web/helpers/browser'

import {LocationChangeHistoryParam, NavigationResult, ThunkApi} from '../interfaces'

const MEMBER_ESCROW_SETTING_URL = `${PAY}/member/escrow/setting`

/** 안전결제 판매 정산 */
const navigateToMemberEscrowSetting = createAsyncThunk<
    NavigationResult,
    LocationChangeHistoryParam | void,
    ThunkApi<unknown>
>('navigateTo/member/escrow/setting', (params) => {
    const {historyType = 'PUSH'} = params ?? {}
    changeBrowserLocation({url: MEMBER_ESCROW_SETTING_URL, type: historyType})
})

export default navigateToMemberEscrowSetting
